import { UserMissingDetailsDto } from 'app/api/apiClient/generated/types';

// Ordering these by number to more easily find missing roles
export enum UserRoles {
  AppManager = 1, // Internal
  TriumphInternal = 2, // Internal
  UserAdmin = 5, // Payors and Factors
  PayorSubmission = 14, // Payor
  PayorReports = 15, // Payor
  Treasury = 18, // Internal
  Underwriting = 20, // Internal
  PayeeAdmin = 21, // Payee
  AccountExecutive = 22, // Internal
  Csr = 23, // Internal
  OpsManager = 24, // Internal
  IntegrationManager = 25, // Internal
  Reviewer = 26, // Internal
  TbcCsr = 27, // Internal
  PayeeDriver = 28, // Payee
  PayeeBilling = 29, // Payee
  CarrierSales = 30, // Internal
  OpsLeadership = 31, // Internal
  SeniorClientServiceAgent = 36, // Internal
  NoaIBEX = 37, // External Vendor
  UnderwritingManager = 38, // Internal
  NoaManagerIBEX = 39, // External Vendor
  IbexCsr = 40, // Internal
  CarrierBankApprover = 41, // Internal
  FraudTeamMember = 42, // Internal
  SeniorNoaProcessor = 43, // Internal
  ExternalOktaUser = 44,
  BrokerSales = 45, // Internal
  NoaAuditIbex = 46, // External Vendor
  ExternalTriumphFactoring = 47, // External Vendor
  TreasuryManager = 48, // Internal
  CarrierConnector = 49, // Internal
  InternalAudit = 50, // INTENRAL
  Devops = 51, // INTERNAL
  FraudManager = 52, // INTERNAL
}
export enum CompanyTypeId {
  Triumph = -1,
  Payor = 1,
  Payee = 2,
  Factor = 3,
  Inactive = 4,
  ExternalVendor = 5,
}

/**
 * partial list of `PayorProfileType` from Core
 */
export enum PayorProfileType {
  ManualUpload = 7,
  DraftSchedule = 9,
  PayeeQuickPayDefault = 10,
  EnableLoads = 20,
  EnableCreditNotes = 29,
  DraftScheduleDayOfWeek = 42,
  DuplicateInvoiceMonitoring = 68,
  EnablePayorInvoiceReview = 69,
  NewRelationshipQuickPayRestrictionSpCount = 84,
  QuickPayRevenueShareCalculatedWeekly = 81689,
  QuickPayRevenueShareThreshold = 81690,
}

export type MissingDetail = keyof UserMissingDetailsDto;
